import {
  TriggerContentWrapper,
  TriggerText
} from "../common/TriggerContentWrapper";

export interface TriggerValueProps {
  /**
   * The selected value to display.
   */
  value: string;
  /**
   * Placeholder text to show when value is empty.
   */
  placeholder?: string;
}

export function SingleTriggerValue({
  value,
  placeholder
}: TriggerValueProps): React.ReactNode {
  const isEmpty = value === undefined || value === null || value === "";
  const displayValue = isEmpty ? placeholder : String(value);

  return (
    <TriggerContentWrapper>
      <TriggerText text={displayValue} />
    </TriggerContentWrapper>
  );
}
